import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	iconButton: {
		padding: 3,
		borderRadius: "100%"
	},
	iconButtonSize: {
		width: 16,
		height: 16
	},
	popover: {
		maxWidth: "550px",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		padding: 16,
		border: "1px solid",
		boxShadow: "none",
		borderColor: colors.gray[200]
	},
	popoverTitle: {
		fontSize: "16px",
		lineHeight: "24px",
		fontWeight: 700
	},
	tip: {
		marginBottom: 8,
		listStyleType: "none"
	},
	exampleMessage: {
		fontSize: "14px",
		lineHeight: "20px",
		fontWeight: 400,
		...ColorUtil.getBackgroundAndContrastColor(colors.green[100]),
		padding: 10,
		borderRadius: 4,
		marginTop: 8
	}
})

export default useStyles
